@if (isVisible) {
  <div class="grid-x margin-bottom">
    <div class="cell large-9 medium-9 small-9">
      <form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>
    </div>
    <div class="cell large-3 medium-3 small-3 text-align-right">
      <button class="button" (click)="export()" [disabled]="!dataLoaded">Export Data</button>
    </div>
  </div>
}
<!-- <ag-grid-angular class="data-grid" [gridOptions]="gridOptions" [rowData]="data$ | async" aria-label="Flow Data Table"></ag-grid-angular> -->
<data-table [hidden]="!isVisible"
  [ariaLabel]="componentData?.title"
  [enabled]="isEnabled"
  #table
    [columns]="columns"
  [dataset]="dataSource"

  [gridOptions]="gridOptions"
  [componentConfig]="componentData.config"
  (onDataLoaded)="onTableDataLoaded($event)">
</data-table>
@if (flowComponent?.page?.pageType === 'summary') {
  <table class="print-only" style="width: 100%;" aria-hidden="true">
    <thead>
      <tr style="width: 100%;">
        @for (column of columns; track column) {
          <th style="text-align: center;" [ngStyle]="{ 'font-size' : columns.length < 10 ? '12pt' : columns.length > 16 ?  '6pt' : '8pt' }">{{column.name}}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of (dataSource | async); track row) {
        <tr style="width: 100%;">
          @for (column of columns; track column) {
            <td style="text-align: center;" [ngStyle]="{ 'font-size' : columns.length < 10 ? '12pt' : columns.length > 16 ?  '6pt' : '8pt' }">
              {{getColumnValue(row, column)}}
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
}

